import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  FAQWrapper: {
    backgroundColor: '#ffd8d1',
    paddingTop: '100px',
    paddingBottom: '90px',
    justifyContent: 'center',
    position: 'relative',
    '& .MuiAccordion-root:before': {
      display: 'none'
    }
  },
  faqHook: {
    position: 'absolute',
    top: '-80px'
  },
  accordianSection: {
    backgroundColor: 'rgba(0,0,0,0)',
     margin: '16px auto!important',
     borderBottom: '1px solid #e6d3cf',
     boxShadow: 'none'
  },
  FAQHeader: {
    color: "black", 
    fontSize: "35px", 
    lineHeight: "50px",
    padding: 20,
    width: '100%',
    textAlign: 'center'
  }
}));